/* Conscious Items Menu V3 (full arm). Intelligems onsite injection. Source and README: conscious-items/menu-v3/injection */
(function () {
'use strict';
/*
  SALE EVENT SLOT (edit here, run `node build.js`, resend both V3 variations).

  enabled  true shows the bright card at the top of the phone drawer and a
           colored first label in the desktop menu, until endsAt.
  title    short line in small capitals on the card, and the desktop label.
           Leave empty to show no small-capitals line (then set label).
  subtitle the main line on the card.
  terms    optional small line under the main line, e.g. a minimum spend.
  label    optional desktop label text; defaults to title.
  note     optional third line. Leave empty to show "Ends today",
           "Ends Sunday" or "Ends Sep 21", worked out from endsAt.
  href     store path without the leading slash, e.g. 'collections/on-sale'.
  endsAt   US Eastern wall time, 'YYYY-MM-DD HH:MM'. After this moment the
           card and label hide themselves, even on an open page.
  offerDialog  true makes the desktop label open the store's offer dialog
           (#ci-offer-modal, "How it works") instead of following href.
           Only for the offer that dialog explains; false for other sales.

  QA preview: add ?civ3sale=1 to any store URL in a V3 arm. It forces the
  slot on for that page view only and does nothing else.
*/
/*
  OFFER LABEL SLOT (edit here, run `node build.js`).

  The drawer offer row and the desktop offer label both show this text. They
  are NOT the SALE block above: they are the entry points to the store's
  "How it works" dialog (snippets/ci-offer-explainer.liquid, rendered from
  sections/header.liquid), and applySlots keeps them hidden unless that dialog
  is on the page AND some non-v3 trigger exists. So they go on and off with
  the dialog, never on their own.

  Empty while no offer is running (2026-10-12 teardown). It previously held
  the label of the 2026-10-02 sitewide sale, which had been expired since
  10-05 while the string still shipped on every page. Set it in the SAME
  change that restores the dialog, to the SAME offer the dialog explains, and
  clear it in the same change that switches the dialog off.
*/
var OFFER_LABEL = '';

var SALE = {
  enabled: false,
  title: '',
  subtitle: '',
  terms: '',
  label: '',
  note: '',
  href: 'collections/popular-items',
  endsAt: '',
  offerDialog: false
};

/*
  GIFTS DESKTOP LABEL SLOT (edit here, run `node build.js`, resend both V3 variations).

  enabled   true shows a seventh desktop label, dated, between startsAt and endsAt.
  label     the desktop label text.
  startsAt  US Eastern wall time, 'YYYY-MM-DD HH:MM'. Before this moment the
            label stays hidden, even on an open page.
  endsAt    US Eastern wall time, 'YYYY-MM-DD HH:MM'. After this moment the
            label hides itself, even on an open page.

  QA preview: add ?civ3gifts=1 to any store URL in a V3 arm. It forces the
  label on for that page view only and does nothing else.
*/
var GIFTS = {
  enabled: true,
  label: 'Gifts',
  startsAt: '2026-11-01 00:00',
  endsAt: '2026-12-24 23:59'
};
if (window.__civ3) return;
var ARM = 'full';
window.__civ3 = ARM;
var STONES = [
['amethyst', 'Amethyst', 'Calm', 'collections/amethyst'],
['rose', 'Rose Quartz', 'Love', 'collections/rose-quartz'],
['tourmaline', 'Black Tourmaline', 'Protection', 'collections/black-tourmaline-jewelry'],
['selenite', 'Selenite', 'Cleansing', 'collections/selenite'],
['citrine', 'Citrine', 'Abundance', 'collections/citrine'],
['moonstone', 'Moonstone', 'Intuition', 'collections/moonstone'],
['tiger', "Tiger's Eye", 'Confidence', 'collections/tigers-eye'],
['obsidian', 'Black Obsidian', 'Grounding', 'collections/black-obsidian-jewelry'],
['clear', 'Clear Quartz', 'Clarity', 'collections/clear-quartz'],
['malachite', 'Malachite', 'Growth', 'collections/malachite'],
['labradorite', 'Labradorite', 'Transformation', 'collections/labradorite-jewelry'],
['lapis', 'Lapis Lazuli', 'Wisdom', 'collections/lapis-lazuli-jewelry']
];
var INTENTS = [
['Protection', 'Protection', 'collections/protection-and-support', 'tourmaline', 'Black Tourmaline, Obsidian', 'obsidian', 'tiger', 28],
['Abundance & Luck', 'Abundance & Luck', 'collections/wealth-and-abundance', 'citrine', "Citrine, Tiger's Eye", 'tiger', 'malachite', 6],
['Calm, Stress & Sleep', 'Calm, Stress & Sleep', 'collections/anxiety-stress-relief', 'amethyst', 'Amethyst, Moonstone', 'moonstone', 'clear', 18],
['Love', 'Love', 'collections/love-and-happiness', 'rose', 'Rose Quartz, Rhodonite', 'rhodonite', 'amethyst', 14],
['Manifestation', 'Manifestation', 'collections/success-and-manifestation', 'clear', 'Clear Quartz, Citrine', 'citrine', 'selenite', 18],
['Self Care', 'Self Care', 'collections/self-care-and-confidence', 'moonstone', 'Moonstone, Rose Quartz', 'rose', 'selenite', 32],
['Focus & Energy', 'Focus', 'collections/balance-and-focus', 'tiger', "Tiger's Eye, Carnelian", 'carnelian', 'citrine', 21],
['New Beginnings', 'New Beginnings', 'collections/change-and-new-beginnings', 'labradorite', 'Labradorite, Moonstone', 'moonstone', 'obsidian', 29],
['Healing & Cleansing', 'Healing', 'collections/healing-and-cleansing', 'selenite', 'Selenite, Clear Quartz', 'clear', 'malachite', 31]
];
var ZODIAC = [
['Aries', 'Mar 21 to Apr 19', 'aries-collection'], ['Taurus', 'Apr 20 to May 20', 'taurus-collection'],
['Gemini', 'May 21 to Jun 20', 'gemini-collection'], ['Cancer', 'Jun 21 to Jul 22', 'cancer-collection'],
['Leo', 'Jul 23 to Aug 22', 'leo-collection'], ['Virgo', 'Aug 23 to Sep 22', 'virgo-collection'],
['Libra', 'Sep 23 to Oct 22', 'libra-collection'], ['Scorpio', 'Oct 23 to Nov 21', 'scorpio-collection'],
['Sagittarius', 'Nov 22 to Dec 21', 'sagittarius-collection'], ['Capricorn', 'Dec 22 to Jan 19', 'capricorn-jewelry'],
['Aquarius', 'Jan 20 to Feb 18', 'aquarius-collection'], ['Pisces', 'Feb 19 to Mar 20', 'pisces-collection']
];
var IMG = {
'p-cord-cutter': ['files/Copyofee71f6ea12b9899089cadfaa7dbc3989_1787557287784-w_1.jpg?v=1789380086', 274, 318, 638],
'p-amethyst-lamp-glow': ['files/i-am-at-peace-spiritual-protection-amethyst-lamp-8956847.jpg?v=1751600716', 128, 206, 788],
'p-arfvedsonite-pendant': ['files/image_40b703a6ccfdb5990129f0b46e8cdbcd-w_1.jpg?v=1789380328', 138, 294, 906],
'p-calm': ['files/Lifestyle-4_1_275d9eb3-63ee-419b-8573-0ba7769457df.jpg?v=1784535540', 282, 268, 642],
'p-triple-protection-bracelet': ['products/the-triple-protection-bracelet-7785560.jpg?v=1762197916'],
'p-abundance': ['files/the-hypersthene-millionaire-manifestation-bracelet-4223950.jpg?v=1762199056'],
'p-black-moonstone': ['files/DSC00083-w-2_1.jpg?v=1774252993'],
'p-amethyst-lamp': ['files/i-am-at-peace-spiritual-protection-amethyst-lamp-6862602.jpg?v=1762198511'],
'p-cleanse-all': ['files/the-cleanse-all-selenite-lamp-2-pounds-of-healing-power-2832992.jpg?v=1762198891'],
't-healing-necklace': ['collections/necklaces-pendants-4073117.jpg?v=1751600710'],
't-anklets': ['files/the-energy-shield-anklet-1019314.jpg?v=1762198175'],
't-rings': ['collections/rings-8341586.jpg?v=1751600725'],
't-healing-crystal-lamps': ['collections/4_56c9896c-7846-460e-bfa1-2051e7611ec9.png?v=1780647918'],
't-crystals-for-car-protection': ['collections/car-crystals-1701024.jpg?v=1751600686'],
't-home': ['collections/home-decor-4914952.jpg?v=1751600628'],
't-gifts-for-her': ['files/cosmic-energy-amplifier-galaxy-tigers-eye-bracelet-4442951.jpg?v=1762199025'],
't-gifts-for-dad': ['files/manifest-success-clear-quartz-lamp-of-achievement-7057864.jpg?v=1762198797'],
't-gifts-for-the-jewelry-lover': ['files/born-to-thrive-copper-bracelet-of-power-5752830.jpg?v=1762198626'],
't-zodiac-sets': ['collections/zodiac-sets-4470260.jpg?v=1751600742'],
't-brand-new-arrivals': ['collections/2_be10f14a-6115-41db-81ec-abc481e1f8f0.png?v=1780647700'],
't-crystal-cleansing': ['collections/crystal-cleansing-7754344.jpg?v=1751600616'],
't-carvings-pyramids': ['products/rose-quartz-love-apples-8104802.jpg?v=1762197970'],
't-crystals': ['collections/7_2e25889c-aae1-4593-a028-d025bc8f5498.png?v=1780648098'],
'p-mahogany-bracelet': ['files/DSC00717-e-3_1.jpg?v=1783330703'],
'p-seraphinite-pendants': ['files/DSC00635-w_2.jpg?v=1783319920'],
'p-hypersthene-bracelet': ['files/the-hypersthene-millionaire-manifestation-bracelet-4223950.jpg?v=1762199056'],
'c-crystal-lamps': ['files/Untitled_design_2_5797f5f0-ac65-450d-8a10-bad3e9967d02.png?v=1789726667'],
'c-car-crystals': ['files/Untitled_design_4_6316d530-1973-4392-8bba-19b88d220a61.png?v=1789726809'],
'c-home-decor': ['files/Untitled_design_7_29318046-1b42-4429-9bbb-7c45a74112b6.png?v=1789726981'],
'c-bracelets': ['files/Untitled_design_3_9706b00f-7676-41fb-86a1-c5ed983e7c5f.png?v=1789726666'],
'c-necklaces': ['files/Untitled_design_1_63f3f81f-a49c-4807-bfa0-b0d8d6651ce7.png?v=1789726667'],
'c-protection': ['files/DSC00083-2-2_2_1.jpg?v=1789717158'],
'c-abundance': ['files/Untitled_design_e183c3de-e2d5-4c77-9ba2-162b5dd1d04a.png?v=1789726667'],
'c-calm': ['files/Copy_of_DSC00161_1_1.jpg?v=1789717160']
};
var PROD = {
tpb: ['triple-protection-bracelet', 'The Triple Protection Bracelet', 'p-triple-protection-bracelet'],
bm: ['black-moonstone', "The Empath's Cord Cutter Black Moonstone Bracelet", 'p-black-moonstone'],
al: ['amethyst-lamp', 'I Am At Peace Amethyst Lamp', 'p-amethyst-lamp'],
ca: ['cleanse-all', 'The Cleanse-All Selenite Lamp', 'p-cleanse-all'],
mb: ['mahogany-bracelet', 'The Self-Sabotage Breaker Mahogany Obsidian Bracelet', 'p-mahogany-bracelet'],
sp: ['seraphinite-pendants', 'By My Side - Rare Seraphinite Pendant', 'p-seraphinite-pendants'],
hb: ['hypersthene-bracelet', 'The Hypersthene Millionaire Manifestation Bracelet', 'p-hypersthene-bracelet']
};
var doc = document;
var html = doc.documentElement;
var ROOT = '/';
function marketRoot() {
var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
return typeof r === 'string' && r.charAt(0) === '/' ? r : '/';
}
function esc(s) {
return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function A(path, inner, cls) {
return '<a href="' + esc(ROOT + path) + '"' + (cls ? ' class="' + cls + '"' : '') + '>' + inner + '</a>';
}
var IC = {
search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
user: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
chev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>',
back: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>'
};
function glyph(i) {
return String.fromCharCode(0x2648 + i) + '\uFE0E';
}
var WIDTHS = [120, 180, 240, 360, 480, 720];
function imgUrl(key, w) {
var d = IMG[key];
var crop = d.length > 1 ? '&crop=region&crop_left=' + d[1] + '&crop_top=' + d[2] + '&crop_width=' + d[3] + '&crop_height=' + d[3] : '';
return '/cdn/shop/' + d[0] + crop + '&width=' + w;
}
function media(key, sizes) {
return '<span class="civ3-media"><img alt="" decoding="async" data-civ3-img="' + key + '" sizes="' + sizes + '"></span>';
}
function hydrate(scope, force) {
if (!scope) return;
var list = scope.querySelectorAll('img[data-civ3-img]');
for (var i = 0; i < list.length; i++) {
var im = list[i];
if (!force && im.closest('[role="tabpanel"][hidden]')) continue;
var key = im.getAttribute('data-civ3-img');
im.removeAttribute('data-civ3-img');
if (!IMG[key]) continue;
im.srcset = WIDTHS.map(function (w) { return imgUrl(key, w) + ' ' + w + 'w'; }).join(', ');
im.src = imgUrl(key, 360);
}
}
var priceReq = {};
function money(cents) {
var out = '';
try {
var t = window.theme;
if (t && t.Currency && t.Currency.formatMoney && t.shopSettings && t.shopSettings.moneyFormat) {
out = String(t.Currency.formatMoney(cents, t.shopSettings.moneyFormat)).replace(/<[^>]*>/g, '');
}
} catch (e) { out = ''; }
if (!out) {
try {
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
out = new Intl.NumberFormat(html.lang || 'en', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(Math.round(cents / 100));
} catch (e2) { out = ''; }
}
return out;
}
function fillPrices(scope) {
var list = scope.querySelectorAll('[data-civ3-price]');
Array.prototype.forEach.call(list, function (el) {
var handle = el.getAttribute('data-civ3-price');
el.removeAttribute('data-civ3-price');
if (!priceReq[handle]) {
priceReq[handle] = fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; })
.catch(function () { return null; });
}
priceReq[handle].then(function (p) {
if (!p || typeof p.price !== 'number') return;
var now = money(p.price);
if (!now) return;
var was = typeof p.compare_at_price === 'number' && p.compare_at_price > p.price ? money(p.compare_at_price) : '';
var onSale = !!(was && was !== now);
el.classList.toggle('civ3-price--sale', onSale);
el.innerHTML = esc(now) + (onSale ? '<s>' + esc(was) + '</s>' : '');
});
});
}
function easternOffset(ms) {
try {
var p = {};
new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour % 24, +p.minute) - Math.floor(ms / 60000) * 60000;
} catch (e) {
return -4 * 3600000;
}
}
function easternToMs(s) {
var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(s || '').trim());
if (!m) return NaN;
var wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
var t = wall - easternOffset(wall);
return wall - easternOffset(t);
}
var SALE_END = easternToMs(SALE.endsAt);
var SALE_QA = /(^|[?&])civ3sale=1(&|$)/.test(location.search.slice(1));
var GIFTS_START = easternToMs(GIFTS.startsAt);
var GIFTS_END = easternToMs(GIFTS.endsAt);
var GIFTS_QA = /(^|[?&])civ3gifts=1(&|$)/.test(location.search.slice(1));
function saleOn() {
return SALE_QA || (SALE.enabled === true && SALE_END > Date.now());
}
function giftsOn() {
return GIFTS_QA || (GIFTS.enabled === true && Date.now() >= GIFTS_START && GIFTS_END > Date.now());
}
function saleNote() {
if (SALE.note) return SALE.note;
if (!(SALE_END > 0)) return '';
try {
var tz = { timeZone: 'America/New_York' };
var day = function (ms) { return new Intl.DateTimeFormat('en-CA', tz).format(new Date(ms)); };
var left = SALE_END - Date.now();
if (left > 0 && day(SALE_END) === day(Date.now())) return 'Ends today';
if (left > 0 && left < 6 * 86400000) return 'Ends ' + new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long' }).format(new Date(SALE_END));
return 'Ends ' + new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric' }).format(new Date(SALE_END));
} catch (e) {
return '';
}
}
function applySlots() {
var on = saleOn();
var list = doc.querySelectorAll('[data-civ3-sale]');
for (var i = 0; i < list.length; i++) list[i].hidden = !on;
var giftsOnNow = giftsOn();
var giftsList = doc.querySelectorAll('[data-civ3-gifts]');
for (var j = 0; j < giftsList.length; j++) giftsList[j].hidden = !giftsOnNow;
var offerOn = !!doc.getElementById('ci-offer-modal') &&
!!doc.querySelector('[data-ci-offer-open]:not([data-ci-offer-open^="v3-"])');
var offerList = doc.querySelectorAll('[data-civ3-offer]');
for (var k = 0; k < offerList.length; k++) {
var barOnly = offerList[k].hasAttribute('data-civ3-offer-bar');
offerList[k].hidden = !offerOn || (barOnly && on);
}
}
function whenReady(test, cb) {
if (test()) { cb(); return; }
if (doc.readyState !== 'loading') { cb(); return; }
var done = false;
var finish = function () {
if (done) return;
done = true;
mo.disconnect();
cb();
};
var mo = new MutationObserver(function () { if (test()) finish(); });
mo.observe(html, { childList: true, subtree: true });
doc.addEventListener('DOMContentLoaded', finish);
}
function guard(fn, part, onFail) {
return function () {
try {
return fn.apply(this, arguments);
} catch (e) {
window.__civ3Error = { part: part, message: String((e && e.message) || e) };
try { if (onFail) onFail(); } catch (e2) {  }
return false;
}
};
}
var DR = { built: false, waiting: false, md: null, body: null, sub: null, opener: null };
var SIZES_TILE3 = '(min-width: 750px) 170px, calc((100vw - 102px) / 3)';
var SIZES_TILE2 = '(min-width: 750px) 260px, calc((100vw - 92px) / 2)';
var SIZES_CARD = '(min-width: 750px) 190px, calc((100vw - 82px) * 0.36)';
function drawerHost() {
var hd = doc.querySelector('sticky-header header-drawer') || doc.querySelector('header-drawer');
var det = hd && hd.querySelector('details');
var md = hd && hd.querySelector('#menu-drawer');
var inner = md && md.querySelector('.menu-drawer__inner-container');
var nav = inner && inner.querySelector('.menu-drawer__navigation-container');
return nav && det ? { hd: hd, det: det, md: md, inner: inner, nav: nav } : null;
}
function drawerReady() {
return !!doc.querySelector('sticky-header .header__heading, sticky-header .header__right, sticky-header header-menu-toggle');
}
function drTop(h) {
var acc = h.md.querySelector('.menu-drawer__account');
var accHref = acc && acc.getAttribute('href') ? acc.getAttribute('href') : ROOT + 'account';
var accText = acc && acc.textContent.replace(/\s+/g, ' ').trim() ? acc.textContent.replace(/\s+/g, ' ').trim() : 'Log in';
return '<div class="civ3-bar"><a class="civ3-login" href="' + esc(accHref) + '">' + IC.user + '<span>' + esc(accText) + '</span></a></div>';
}
function drSearch() {
return '<div class="civ3-search-wrap" data-civ3-search-mount></div>';
}
function drSearchFallback() {
return '<form class="civ3-search search-modal__form" role="search" action="' + esc(ROOT + 'search') + '" method="get">' +
'<input type="search" name="q" placeholder="Search crystals, bracelets, lamps" autocomplete="off" enterkeyhint="search" aria-label="Search">' +
'<input type="hidden" name="type" value="product">' +
'<button type="submit" class="civ3-search-go" aria-label="Search">' + IC.search + '</button>' +
'</form>';
}
var SEARCH_ID_SUFFIX = '-civ3';
var SEARCH_REF_ATTRS = ['for', 'aria-owns', 'aria-controls', 'aria-labelledby', 'aria-describedby'];
function suffixSearchIds(root, suffix) {
suffix = suffix || SEARCH_ID_SUFFIX;
var map = {}, i, j, el, oldId, newId;
var idEls = root.querySelectorAll('[id]');
for (i = 0; i < idEls.length; i++) {
el = idEls[i];
oldId = el.id;
if (!oldId || oldId.slice(-1 * suffix.length) === suffix) continue;
newId = oldId + suffix;
map[oldId] = newId;
el.id = newId;
}
var refEls = root.querySelectorAll('[for],[aria-owns],[aria-controls],[aria-labelledby],[aria-describedby]');
for (i = 0; i < refEls.length; i++) {
el = refEls[i];
for (j = 0; j < SEARCH_REF_ATTRS.length; j++) {
var val = el.getAttribute(SEARCH_REF_ATTRS[j]);
if (val && map[val]) el.setAttribute(SEARCH_REF_ATTRS[j], map[val]);
}
}
}
function guardMenuDrawerClose(input) {
if (!input) return;
var HD = (typeof customElements === 'undefined') ? null : (customElements.get('header-drawer') || customElements.get('menu-drawer'));
var proto = HD && HD.prototype;
if (!proto || !proto.onBodyClick || proto.__civ3Patched) return;
var orig = proto.onBodyClick;
proto.onBodyClick = function (e) {
if (doc.activeElement === input) return;
return orig.apply(this, arguments);
};
proto.__civ3Patched = true;
}
function mountSearchClone(wrap) {
try {
if (typeof customElements === 'undefined' || !customElements.get('predictive-search')) return false;
var src = doc.querySelector('predictive-search');
if (!src) return false;
var clone = src.cloneNode(true);
clone.removeAttribute('open');
clone.removeAttribute('loading');
clone.removeAttribute('results');
var form = clone.querySelector('form.search');
if (!form) return false;
form.classList.add('civ3-search');
form.classList.add('search-modal__form');
var input = clone.querySelector('input[type="search"]');
if (input) input.setAttribute('placeholder', 'Search crystals, bracelets, lamps');
suffixSearchIds(clone);
wrap.appendChild(clone);
wrap.addEventListener('focusout', function (e) { e.stopPropagation(); });
guardMenuDrawerClose(input);
var results = clone.querySelector('[data-predictive-search]');
if (results && typeof MutationObserver !== 'undefined') {
new MutationObserver(function () { suffixSearchIds(clone); }).observe(results, { childList: true, subtree: true });
}
clone.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && clone.hasAttribute('open')) {
e.stopPropagation();
if (typeof clone.close === 'function') clone.close(true);
}
});
return true;
} catch (e) {
return false;
}
}
function trySearchMount(wrap, attempt) {
if (mountSearchClone(wrap)) return;
if (attempt >= 20) { wrap.innerHTML = drSearchFallback(); return; }
setTimeout(function () { trySearchMount(wrap, attempt + 1); }, 250);
}
function drEvent() {
var note = saleNote();
return '<a class="civ3-evt" href="' + esc(ROOT + SALE.href) + '" data-civ3-sale hidden><span class="civ3-evt-t">' + (SALE.title ? '<em>' + esc(SALE.title) + '</em>' : '') + '<b>' + esc(SALE.subtitle) + '</b>' +
(SALE.terms ? '<small>' + esc(SALE.terms) + '</small>' : '') +
(note ? '<small>' + esc(note) + '</small>' : '') + '</span><span class="civ3-evt-go" aria-hidden="true">' + IC.chev + '</span></a>';
}
function drHead(title, path, linkText) {
return '<div class="civ3-h"><span>' + esc(title) + '</span>' + A(path, esc(linkText)) + '</div>';
}
function drTile(label, path, img, sizes) {
return A(path, media(img, sizes) + '<span class="civ3-tile-t">' + esc(label) + '</span>', 'civ3-tile');
}
function drPair(a, b, c) {
return '<span class="civ3-pair" aria-hidden="true"><i class="civ3-s-' + a + '"></i><i class="civ3-s-' + b + '"></i>' +
(c ? '<i class="civ3-s-' + c + '"></i>' : '') + '</span>';
}
function drPanelButton(cls, label, id, chev) {
return '<button type="button" class="' + cls + '" data-civ3-panel aria-expanded="false" aria-controls="civ3-sub-' + id + '"><span>' + esc(label) + '</span>' + (chev ? IC.chev : '') + '</button>';
}
function drSub(id, title, inner) {
return '<section class="civ3 civ3-sub" id="civ3-sub-' + id + '" aria-label="' + esc(title) + '" data-ci-nav-root>' +
'<div class="civ3-sub-head"><button type="button" class="civ3-back" data-civ3-back aria-label="Back">' + IC.back + '</button><b>' + esc(title) + '</b></div>' +
inner + '</section>';
}
function drZodiac() {
return '<div class="civ3-zod">' + ZODIAC.map(function (z, i) {
return A('collections/' + z[2], '<span class="civ3-g" aria-hidden="true">' + glyph(i) + '</span><b>' + esc(z[0]) + '</b><span class="civ3-zd">' + esc(z[1]) + '</span>');
}).join('') + '</div>';
}
function drService() {
return '<hr class="civ3-band"><div class="civ3-svc">' +
A('pages/conscious-rewards', 'Conscious Rewards') + A('a/track', 'Track my order') +
A('pages/help-center', 'Help center') + A('pages/contact-us', 'Contact us') + '</div>';
}
function buildDrawer() {
if (DR.built) return true;
var h = drawerHost();
if (!h) return false;
if (h.det.hasAttribute('open')) {
if (!DR.waiting) {
DR.waiting = true;
doc.addEventListener('menudrawer:close', function retry() {
setTimeout(function () {
if (h.det.hasAttribute('open')) return;
doc.removeEventListener('menudrawer:close', retry);
DR.waiting = false;
guardedBuildDrawer();
}, 450);
});
}
return false;
}
ROOT = marketRoot();
var main = '<div class="civ3 civ3-dr civ3-dr--' + ARM + '" data-ci-nav-root data-animate data-animate-delay-1>' + drTop(h) +
'<div class="civ3-body">' + drawerMain() + '</div></div>';
var subs = drawerSubs();
h.nav.insertAdjacentHTML('beforeend', main);
h.inner.insertAdjacentHTML('beforeend', subs);
var searchWrap = h.nav.querySelector('.civ3-search-wrap[data-civ3-search-mount]');
if (searchWrap) trySearchMount(searchWrap, 0);
DR.md = h.md;
DR.body = h.nav.querySelector('.civ3-dr .civ3-body');
bindDrawer(h);
html.classList.add('civ3-dr-on');
applySlots();
DR.built = true;
return true;
}
function undoDrawer() {
html.classList.remove('civ3-dr-on');
var list = doc.querySelectorAll('#menu-drawer .civ3');
for (var i = 0; i < list.length; i++) list[i].parentNode.removeChild(list[i]);
DR.body = null;
DR.built = true;
}
var guardedBuildDrawer = guard(buildDrawer, 'drawer', undoDrawer);
function openSub(btn) {
var sub = doc.getElementById(btn.getAttribute('aria-controls'));
if (!sub) return;
if (DR.sub && DR.sub !== sub) closeSub(false);
hydrate(sub);
sub.scrollTop = 0;
sub.classList.add('is-open');
btn.setAttribute('aria-expanded', 'true');
DR.sub = sub;
DR.opener = btn;
if (DR.body) DR.body.inert = true;
var back = sub.querySelector('[data-civ3-back]');
if (back) back.focus({ preventScroll: true });
}
function closeSub(returnFocus) {
var sub = DR.sub, btn = DR.opener;
if (!sub) return;
sub.classList.remove('is-open');
if (DR.body) DR.body.inert = false;
if (btn) btn.setAttribute('aria-expanded', 'false');
DR.sub = null;
DR.opener = null;
if (returnFocus && btn) btn.focus({ preventScroll: true });
}
function selectTab(tab, moveFocus) {
var tabs = tab.parentNode.querySelectorAll('[role="tab"]');
for (var i = 0; i < tabs.length; i++) {
var on = tabs[i] === tab;
tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
tabs[i].tabIndex = on ? 0 : -1;
var panel = doc.getElementById(tabs[i].getAttribute('aria-controls'));
if (!panel) continue;
panel.hidden = !on;
if (on) {
hydrate(panel);
var cards = panel.querySelector('.civ3-cards');
if (cards) cards.scrollLeft = 0;
}
}
if (moveFocus) tab.focus();
}
function bindDrawer(h) {
h.md.addEventListener('click', function (e) {
var t = e.target;
if (!t || !t.closest) return;
var el;
if ((el = t.closest('[data-civ3-panel]'))) openSub(el);
else if ((el = t.closest('[data-civ3-back]'))) closeSub(true);
else if ((el = t.closest('.civ3 [role="tab"]'))) selectTab(el, false);
});
h.md.addEventListener('pointerdown', function (e) {
var t = e.target, el;
if (!t || !t.closest) return;
if ((el = t.closest('[data-civ3-panel], .civ3 [role="tab"]'))) hydrate(doc.getElementById(el.getAttribute('aria-controls')), true);
}, { passive: true });
h.md.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && DR.sub) {
e.stopPropagation();
closeSub(true);
}
});
h.md.addEventListener('keydown', function (e) {
var tab = e.target && e.target.closest && e.target.closest('.civ3 [role="tab"]');
if (!tab) return;
var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
var i = tabs.indexOf(tab), n = tabs.length, next = -1;
if (e.key === 'ArrowRight') next = (i + 1) % n;
else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
else if (e.key === 'Home') next = 0;
else if (e.key === 'End') next = n - 1;
if (next < 0) return;
e.preventDefault();
selectTab(tabs[next], true);
});
h.hd.addEventListener('close', function () {
setTimeout(function () { if (!h.det.hasAttribute('open')) closeSub(false); }, 450);
});
}
function hydrateDrawer() {
if (!DR.built || !DR.body) return;
hydrate(DR.body);
}
function drawerMain() {
var chips = ['Love', 'Manifestation', 'Self Care', 'Focus & Energy', 'New Beginnings'].map(function (label) {
var t = INTENTS.filter(function (x) { return x[0] === label; })[0];
return A(t[2], drPair(t[3], t[5]) + '<span>' + esc(t[1]) + '</span>', 'civ3-chip');
}).join('');
var stones = STONES.slice(0, 8).map(function (s) {
return A(s[3], '<i class="civ3-sw civ3-s-' + s[0] + '" aria-hidden="true"></i><b>' + esc(s[1]) + '</b><span>' + esc(s[2]) + '</span>', 'civ3-stone');
}).join('');
return drSearch() + drEvent() +
'<div class="civ3-sec">' + drHead('Shop by category', 'collections/all-products-in-stock', 'Shop all') + '<div class="civ3-tiles">' +
drTile('Bracelets', 'collections/bracelet', 'c-bracelets', SIZES_TILE3) +
drTile('Crystal Lamps', 'collections/healing-crystal-lamps', 'c-crystal-lamps', SIZES_TILE3) +
drTile('Necklaces', 'collections/healing-necklace', 'c-necklaces', SIZES_TILE3) +
'</div></div>' +
'<div class="civ3-sec">' + drHead('Shop by intention', 'pages/by-intention', 'See all') + '<div class="civ3-tiles">' +
drTile('Protection', 'collections/protection-and-support', 'c-protection', SIZES_TILE3) +
drTile('Abundance & Luck', 'collections/wealth-and-abundance', 'c-abundance', SIZES_TILE3) +
drTile('Calm, Stress & Sleep', 'collections/anxiety-stress-relief', 'c-calm', SIZES_TILE3) +
'</div><div class="civ3-chips">' + chips + '</div></div>' +
'<div class="civ3-sec">' + drHead('Shop by crystal', 'pages/by-crystal', 'See all') + '<div class="civ3-stones">' + stones + '</div></div>' +
'<div class="civ3-rows">' +
'<a class="civ3-row civ3-row--offer" href="' + esc(ROOT + 'collections/popular-items') + '" data-ci-offer-open="v3-drawer" aria-haspopup="dialog" data-civ3-offer hidden>' +
'<span>' + esc(OFFER_LABEL) + '</span><span class="civ3-row-cue">How it works</span></a>' +
A('collections/popular-items', '<span>Best Sellers</span>' + IC.chev, 'civ3-row') +
A('collections/brand-new-arrivals', '<span>New Arrivals</span>' + IC.chev, 'civ3-row') +
drPanelButton('civ3-row', 'All Jewelry', 'jewelry', true) +
drPanelButton('civ3-row', 'Crystals & Home', 'crystals', true) +
drPanelButton('civ3-row', 'Gifts', 'gifts', true) +
drPanelButton('civ3-row', 'Shop by Zodiac', 'zodiac', true) +
A('collections/on-sale', '<span>Sale</span>' + IC.chev, 'civ3-row') +
'</div>' +
drService() +
A('pages/all-reviews', '<span class="civ3-stars" aria-hidden="true">' + new Array(6).join(String.fromCharCode(0x2605)) + '</span><span>Rated 4.9 from 15,900+ reviews</span>', 'civ3-proof');
}
function fullRows(list) {
return '<div class="civ3-rows civ3-rows--flush">' + list.map(function (r) {
return A('collections/' + r[1], '<span>' + esc(r[0]) + '</span>' + IC.chev, 'civ3-row');
}).join('') + '</div>';
}
function drawerSubs() {
return drSub('gifts', 'Gifts',
'<div class="civ3-tiles">' +
drTile('For Her', 'collections/gifts-for-her', 't-gifts-for-her', SIZES_TILE2) +
drTile('For Him', 'collections/gifts-for-dad', 't-gifts-for-dad', SIZES_TILE2) +
drTile('For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover', 't-gifts-for-the-jewelry-lover', SIZES_TILE2) +
drTile('Zodiac Gift Sets', 'collections/zodiac-sets', 't-zodiac-sets', SIZES_TILE2) +
'</div>' +
'<div class="civ3-rows civ3-rows--gap">' +
[['Gift bundles', 'bundles'], ['Gifts under $25', '0-25'], ['Gifts $25 to $35', '25-35'], ['Gifts $35 to $50', '35-50'], ['Gifts $50 to $75', '50-75']].map(function (r) {
return A('collections/' + r[1], '<span>' + esc(r[0]) + '</span>' + IC.chev, 'civ3-row');
}).join('') +
'</div>') +
drSub('zodiac', 'Shop by Zodiac',
drZodiac() + '<div class="civ3-rows">' + A('collections/zodiac-sets', '<span>Zodiac Gift Sets</span>' + IC.chev, 'civ3-row') + '</div>') +
drSub('jewelry', 'All Jewelry', fullRows([
['Bracelets', 'bracelet'], ['Necklaces & Pendants', 'healing-necklace'], ['Anklets', 'anklets'], ['Rings', 'rings'],
['Demi-Fine Silver', 'demi-fine-silver-jewelry'], ['For Men', 'crystals-for-men'], ['Bracelet Sets', 'bracelet-sets'], ['Shop all jewelry', 'jewelry']
])) +
drSub('crystals', 'Crystals & Home', fullRows([
['Crystal Lamps', 'healing-crystal-lamps'], ['Car Crystals', 'crystals-for-car-protection'], ['Home Decor', 'home'], ['Crystal Cleansing', 'crystal-cleansing'],
['Carvings & Pyramids', 'carvings-pyramids'], ['Crystal Sets', 'crystals'], ['Shop all crystals', 'crystals-all']
]));
}
var DK = { built: false, bar: null, items: [], open: null, openTimer: 0, closeTimer: 0, touchAt: 0, scrollY: 0 };
var SIZES_PCARD = '(min-width: 1440px) 260px, 18vw';
var SIZES_SQ = '(min-width: 1440px) 300px, 22vw';
function desktopReady() {
return !!doc.querySelector('sticky-header .header__right');
}
function dkLinks(title, items, extra) {
return '<div' + (extra ? ' class="' + extra + '"' : '') + '><div class="civ3-col-h">' + esc(title) + '</div><div class="civ3-links">' +
items.map(function (i) { return A(i[1], esc(i[0]), i[2] ? 'civ3-' + i[2] : ''); }).join('') + '</div></div>';
}
function dkCard(key, badge) {
var p = PROD[key];
return A('products/' + p[0], (badge ? '<span class="civ3-badge">' + esc(badge) + '</span>' : '') + media(p[2], SIZES_PCARD) +
'<span class="civ3-pname">' + esc(p[1]) + '</span><span class="civ3-price" data-civ3-price="' + p[0] + '"></span>', 'civ3-pcard');
}
function dkSquares(title, items, pills) {
return '<div><div class="civ3-col-h">' + esc(title) + '</div><div class="civ3-sqgrid">' +
items.map(function (i) {
return A(i[1], media(i[2], SIZES_SQ) + '<span>' + esc(i[0]) + '</span>', 'civ3-sq');
}).join('') + '</div>' +
(pills ? '<div class="civ3-pills civ3-pills--tight">' + pills.map(function (i) {
return A(i[1], esc(i[0]), 'civ3-pill' + (i[2] ? ' civ3-pill--all' : ''));
}).join('') + '</div>' : '') + '</div>';
}
var MEGAS = [
['Best Sellers', 'best', function () {
return dkLinks('Most loved', [['Shop all', 'collections/all-products-in-stock', 'all'], ['Best Sellers', 'collections/popular-items', 'all'], ['New Arrivals', 'collections/brand-new-arrivals'], ['Trending Now', 'collections/trending'], ['Back in Stock', 'collections/back-in-stock'], ['Sale', 'collections/on-sale']]) +
dkLinks('Gift ideas', [['For Her', 'collections/gifts-for-her'], ['For Him', 'collections/gifts-for-dad'], ['For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover'], ['Zodiac Gift Sets', 'collections/zodiac-sets'], ['Gift bundles', 'collections/bundles'], ['Gifts under $25', 'collections/0-25']]) +
dkCard('tpb', '#1 best seller') + dkCard('bm') + dkCard('al');
}],
['Jewelry', 'jewelry', function () {
return dkLinks('Jewelry', [['All Jewelry', 'collections/jewelry', 'all'], ['Bracelets', 'collections/bracelet'], ['Necklaces & Pendants', 'collections/healing-necklace'], ['Anklets', 'collections/anklets'], ['Rings', 'collections/rings'], ['Bracelet Sets', 'collections/bracelet-sets'], ['Demi-Fine Silver', 'collections/demi-fine-silver-jewelry'], ['For Men', 'collections/crystals-for-men']]) +
dkLinks('By intention', [['Protection', 'collections/protection-and-support'], ['Abundance & Luck', 'collections/wealth-and-abundance'], ['Calm, Stress & Sleep', 'collections/anxiety-stress-relief'], ['Love', 'collections/love-and-happiness'], ['Manifestation', 'collections/success-and-manifestation'], ['For Empaths', 'collections/crystals-jewelry-for-empaths']]) +
dkLinks('By crystal', [["Tiger's Eye", 'collections/tigers-eye'], ['Amethyst', 'collections/amethyst'], ['Black Obsidian', 'collections/black-obsidian-jewelry'], ['Rose Quartz', 'collections/rose-quartz'], ['Clear Quartz', 'collections/clear-quartz'], ['Moonstone', 'collections/moonstone'], ['Citrine', 'collections/citrine'], ['See all crystals', 'pages/by-crystal', 'all']]) +
dkCard('mb', 'Top rated') + dkCard('sp', 'Top necklace');
}],
['Lamps & Home', 'home', function () {
return dkSquares('Shop by category', [
['Crystal Lamps', 'collections/healing-crystal-lamps', 'c-crystal-lamps'],
['Car Crystals', 'collections/crystals-for-car-protection', 'c-car-crystals'],
['Home Decor', 'collections/home', 'c-home-decor'],
['Crystal Cleansing', 'collections/crystal-cleansing', 't-crystal-cleansing'],
['Carvings & Pyramids', 'collections/carvings-pyramids', 't-carvings-pyramids'],
['Crystal Sets', 'collections/crystals', 't-crystals']
], [['Shop all crystals', 'collections/crystals-all', 'all']]) +
dkCard('ca', 'Cleansing favorite');
}],
['Intentions', 'intentions', function () {
return '<div><div class="civ3-col-h">Shop by intention</div><div class="civ3-intgrid">' + INTENTS.map(function (t) {
return A(t[2], drPair(t[3], t[5], t[6]) + '<b>' + esc(t[0]) + '</b><span>' + esc(t[4]) +
(t[7] ? ' <span class="civ3-more">+ ' + t[7] + ' more</span>' : '') + '</span>');
}).join('') + '</div></div>' +
'<div><div class="civ3-col-h">By zodiac sign</div><div class="civ3-zmini">' + ZODIAC.map(function (z, i) {
return A('collections/' + z[2], '<span class="civ3-g" aria-hidden="true">' + glyph(i) + '</span>' + esc(z[0]));
}).join('') + '</div></div>' +
dkCard('hb', 'Abundance pick');
}],
['By Crystal', 'crystal', function () {
return '<div class="civ3-swgrid">' + STONES.map(function (s) {
return A(s[3], '<i class="civ3-sw civ3-s-' + s[0] + '" aria-hidden="true"></i><b>' + esc(s[1]) + '</b><span>' + esc(s[2]) + '</span>');
}).join('') + '</div>' +
'<div class="civ3-links civ3-links-inline">' + A('pages/by-crystal', 'See all crystals', 'civ3-all') + A('pages/crystals-and-their-meanings', 'Crystal meanings') + A('pages/quiz-best-crystal-for-me', 'Not sure? Take the crystal quiz') + '</div>';
}],
['Gifts', 'gifts', function () {
return dkSquares('Gift ideas', [
['For Her', 'collections/gifts-for-her', 't-gifts-for-her'],
['For Him', 'collections/gifts-for-dad', 't-gifts-for-dad'],
['For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover', 't-gifts-for-the-jewelry-lover'],
['Zodiac Gift Sets', 'collections/zodiac-sets', 't-zodiac-sets']
], [['Gift bundles', 'collections/bundles'], ['Under $25', 'collections/0-25'], ['$25 to $35', 'collections/25-35'], ['$35 to $50', 'collections/35-50'], ['$50 to $75', 'collections/50-75']]);
}, 'dated']
];
var DK_HREF = {
best: 'collections/popular-items',
jewelry: 'collections/jewelry',
home: 'collections/crystals-all',
intentions: 'pages/by-intention',
crystal: 'pages/by-crystal',
gifts: 'collections/gifts-for-her'
};
function desktopHTML() {
var out = '<div class="civ3 civ3-dk" data-ci-nav-root><ul class="civ3-dk-list" role="list">' +
'<li class="civ3-dk-offer" data-civ3-offer data-civ3-offer-bar hidden><a class="civ3-dk-label civ3-dk-label--offer" href="' + esc(ROOT + 'collections/popular-items') + '" data-ci-offer-open="v3-desktop" aria-haspopup="dialog">' +
'<span class="civ3-dk-offer__mark"><span>' + esc(OFFER_LABEL) + '</span><i class="civ3-dk-offer__cue" aria-hidden="true">?</i></span></a></li>' +
'<li class="civ3-dk-sale" data-civ3-sale hidden><a class="civ3-dk-label civ3-dk-label--sale" href="' + esc(ROOT + SALE.href) + '"' + (SALE.offerDialog === true ? ' data-ci-offer-open="v3-desktop-sale" aria-haspopup="dialog"' : '') + '><span>' + esc(SALE.label || SALE.title) + '</span></a></li>';
MEGAS.forEach(function (m) {
var key = m[1], label = m[0], content = m[2], dated = m[3] === 'dated';
if (typeof content === 'string') {
out += '<li class="civ3-dk-item civ3-dk-item--link" data-ci-nav-label="v3-' + key + '"><a class="civ3-dk-label" href="' + esc(ROOT + content) + '">' + esc(label) + '</a></li>';
return;
}
var liLabel = dated ? esc(GIFTS.label) : esc(label);
var href = DK_HREF[key];
var ctl = ' class="civ3-dk-label" aria-expanded="false" aria-controls="civ3-mega-' + key + '"';
out += '<li class="civ3-dk-item" data-ci-nav-label="v3-' + key + '"' + (dated ? ' data-civ3-gifts hidden' : '') + '>' +
(href ? '<a href="' + esc(ROOT + href) + '"' + ctl + '>' + liLabel + '</a>' : '<button type="button"' + ctl + '>' + liLabel + '</button>') +
'<div class="civ3-mega" id="civ3-mega-' + key + '" role="region" aria-label="' + liLabel + '" hidden><div class="civ3-mi civ3-mi--' + key + '">' + content() + '</div></div></li>';
});
return out + '</ul></div>';
}
var DKS_PLACEHOLDER = 'Search crystals, bracelets, lamps';
var DKS_ID_SUFFIX = '-civ3d';
function undoDesktopSearch() {
html.classList.remove('civ3-dks-on');
var wrap = doc.querySelector('sticky-header .header__left > .civ3-dks');
if (wrap) wrap.parentNode.removeChild(wrap);
}
function mountDesktopSearch() {
var wrap = null;
try {
var left = doc.querySelector('sticky-header .header__left');
var modal = left && left.querySelector(':scope > search-modal');
var src = modal && modal.querySelector('predictive-search');
if (!left || !modal || !src) return;
var clone = src.cloneNode(true);
clone.removeAttribute('open');
clone.removeAttribute('loading');
clone.removeAttribute('results');
var form = clone.querySelector('form.search');
if (!form) return;
var input = clone.querySelector('input[type="search"]');
if (input) {
input.setAttribute('placeholder', DKS_PLACEHOLDER);
input.setAttribute('aria-label', 'Search');
}
suffixSearchIds(clone, DKS_ID_SUFFIX);
var results = clone.querySelector('[data-predictive-search]');
if (results && typeof MutationObserver !== 'undefined') {
new MutationObserver(function () { suffixSearchIds(clone, DKS_ID_SUFFIX); }).observe(results, { childList: true, subtree: true });
}
clone.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && clone.hasAttribute('open')) {
e.stopPropagation();
if (typeof clone.close === 'function') clone.close(true);
}
});
wrap = doc.createElement('div');
wrap.className = 'civ3 civ3-dks';
wrap.appendChild(clone);
modal.insertAdjacentElement('afterend', wrap);
html.classList.add('civ3-dks-on');
} catch (e) {
undoDesktopSearch();
}
}
function buildDesktop() {
if (DK.built) return true;
var nav = doc.querySelector('sticky-header nav.header__inline-menu');
if (!nav) {
DK.built = true;
html.classList.add('civ3-dk-fail');
return false;
}
ROOT = marketRoot();
nav.insertAdjacentHTML('beforeend', desktopHTML());
DK.bar = nav.lastElementChild;
var lis = DK.bar.querySelectorAll('.civ3-dk-item');
for (var i = 0; i < lis.length; i++) {
var panel = lis[i].querySelector('.civ3-mega');
if (!panel) continue;
DK.items.push({ li: lis[i], btn: lis[i].querySelector('.civ3-dk-label'), panel: panel });
}
bindDesktop();
html.classList.add('civ3-dk-on');
try { mountDesktopSearch(); } catch (e) { undoDesktopSearch(); }
applySlots();
DK.built = true;
return true;
}
function undoDesktop() {
html.classList.remove('civ3-dk-on');
html.classList.add('civ3-dk-fail');
var bar = doc.querySelector('nav.header__inline-menu > .civ3-dk');
if (bar) bar.parentNode.removeChild(bar);
undoDesktopSearch();
DK.built = true;
DK.items = [];
DK.open = null;
}
function itemOf(el) {
for (var i = 0; i < DK.items.length; i++) if (DK.items[i].li === el || DK.items[i].li.contains(el)) return DK.items[i];
return null;
}
function warmMega(it) {
hydrate(it.panel);
fillPrices(it.panel);
}
function placeMega(it) {
var sh = doc.querySelector('sticky-header') || DK.bar;
var r = sh.getBoundingClientRect();
var b = DK.bar.getBoundingClientRect();
it.panel.style.left = (r.left - b.left) + 'px';
it.panel.style.width = r.width + 'px';
it.panel.style.top = (r.bottom - b.top) + 'px';
it.panel.style.maxHeight = Math.max(240, Math.round(window.innerHeight - r.bottom)) + 'px';
}
function openMega(it) {
clearTimeout(DK.openTimer);
clearTimeout(DK.closeTimer);
if (DK.open === it) return;
if (DK.open) closeMega(false);
warmMega(it);
it.panel.hidden = false;
placeMega(it);
it.btn.setAttribute('aria-expanded', 'true');
it.li.classList.add('is-open');
DK.open = it;
DK.scrollY = window.pageYOffset;
}
function closeMega(returnFocus) {
clearTimeout(DK.openTimer);
clearTimeout(DK.closeTimer);
var it = DK.open;
if (!it) return;
it.panel.hidden = true;
it.btn.setAttribute('aria-expanded', 'false');
it.li.classList.remove('is-open');
DK.open = null;
if (returnFocus) it.btn.focus();
}
function focusables(panel) {
return panel.querySelectorAll('a[href], button');
}
function bindDesktop() {
DK.items.forEach(function (it) {
it.li.addEventListener('mouseenter', function () {
if (Date.now() - DK.touchAt < 800) return;
clearTimeout(DK.closeTimer);
warmMega(it);
if (DK.open && DK.open !== it) { openMega(it); return; }
if (DK.open === it) return;
clearTimeout(DK.openTimer);
DK.openTimer = setTimeout(function () { openMega(it); }, 60);
});
it.li.addEventListener('mouseleave', function () {
if (Date.now() - DK.touchAt < 800) return;
clearTimeout(DK.openTimer);
if (DK.open === it) DK.closeTimer = setTimeout(function () { closeMega(false); }, 200);
});
it.btn.addEventListener('click', function (e) {
var viaMouse = e.detail > 0 && Date.now() - DK.touchAt > 800;
if (it.btn.tagName === 'A') {
if (!viaMouse && e.detail > 0 && DK.open !== it) {
e.preventDefault();
openMega(it);
}
return;
}
if (DK.open === it) {
if (!viaMouse) closeMega(false);
} else {
openMega(it);
}
});
it.btn.addEventListener('keydown', function (e) {
var visible = DK.items.filter(function (x) { return !x.li.hidden; });
var vi = visible.indexOf(it);
if (vi < 0) vi = 0;
var n = visible.length, next = -1;
if (e.key === 'ArrowRight') next = (vi + 1) % n;
else if (e.key === 'ArrowLeft') next = (vi - 1 + n) % n;
else if (e.key === 'Home') next = 0;
else if (e.key === 'End') next = n - 1;
if (next >= 0) {
e.preventDefault();
if (DK.open) openMega(visible[next]);
visible[next].btn.focus();
return;
}
if (e.key === 'ArrowDown') {
e.preventDefault();
openMega(it);
var f = focusables(it.panel);
if (f.length) f[0].focus();
}
});
it.li.addEventListener('focusout', function (e) {
if (DK.open === it && e.relatedTarget && !it.li.contains(e.relatedTarget)) closeMega(false);
});
});
var linkLis = DK.bar.querySelectorAll('.civ3-dk-item--link');
for (var li = 0; li < linkLis.length; li++) {
linkLis[li].addEventListener('mouseenter', function () {
clearTimeout(DK.openTimer);
if (DK.open) closeMega(false);
});
}
DK.bar.addEventListener('keydown', function (e) {
if (!DK.open || !DK.open.panel.contains(e.target)) return;
if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
var f = Array.prototype.slice.call(focusables(DK.open.panel));
var i = f.indexOf(e.target);
if (i < 0) return;
e.preventDefault();
if (e.key === 'ArrowDown') f[Math.min(i + 1, f.length - 1)].focus();
else if (i === 0) DK.open.btn.focus();
else f[i - 1].focus();
});
doc.addEventListener('keydown', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && DK.open) {
var inside = DK.open.li.contains(doc.activeElement);
closeMega(inside);
}
});
doc.addEventListener('click', function (e) {
if (DK.open && !DK.open.li.contains(e.target)) closeMega(false);
});
window.addEventListener('pointerdown', function (e) {
if (e.pointerType && e.pointerType !== 'mouse') DK.touchAt = Date.now();
}, { capture: true, passive: true });
window.addEventListener('scroll', function () {
if (DK.open && Math.abs(window.pageYOffset - DK.scrollY) > 60) closeMega(false);
}, { passive: true });
window.addEventListener('resize', function () {
if (DK.open) closeMega(false);
});
}
var guardedBuildDesktop = guard(buildDesktop, 'desktop', undoDesktop);
function onMenuIntent(e) {
var t = e.target;
if (!t || !t.closest) return;
var s = t.closest('summary.header__icon--menu');
if (!s || !s.closest('header-drawer')) return;
if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
if (!DR.built && drawerHost() && drawerReady()) guardedBuildDrawer();
if (DR.built) {
applySlots();
hydrateDrawer();
}
}
['touchstart', 'pointerdown', 'mousedown', 'keydown', 'click'].forEach(function (type) {
window.addEventListener(type, onMenuIntent, { capture: true, passive: true });
});
whenReady(drawerReady, guardedBuildDrawer);
whenReady(desktopReady, guardedBuildDesktop);
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', applySlots);
if (!SALE_QA && SALE.enabled === true && SALE_END > Date.now() && SALE_END - Date.now() < 2147000000) {
setTimeout(applySlots, SALE_END - Date.now() + 1000);
}
if (!GIFTS_QA && GIFTS.enabled === true) {
if (GIFTS_START > Date.now() && GIFTS_START - Date.now() < 2147000000) {
setTimeout(applySlots, GIFTS_START - Date.now() + 1000);
}
if (GIFTS_END > Date.now() && GIFTS_END - Date.now() < 2147000000) {
setTimeout(applySlots, GIFTS_END - Date.now() + 1000);
}
}
})();
